<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>渠道分类</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >  
                <span class="label-span">
                    <label class="label">短信签名</label> 
                    <el-input v-model.trim="query.templateName" placeholder="短信签名" class="handle-input mr10"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">短信服务商</label> 
                    <el-select v-model="query.smsFrom"  placeholder="短信服务商" clearable class="handle-select mr10"> 
                        <el-option value="" label="全部"  />   
                        <el-option value="1" label="阿里云"  /> 
                        <el-option value="2" label="腾讯云"  /> 
                    </el-select>
                </span>   
                <span class="label-span">
                    <label class="label">短信类型</label> 
                    <el-select v-model="query.smsType"  placeholder="短信类型" clearable class="handle-select mr15">
                        <el-option value="" label="全部"  />   
                        <el-option value="1" label="验证码"  /> 
                        <el-option value="2" label="运营通知"  /> 
                        <el-option value="3" label="订单通知"  /> 
                        <el-option value="4" label="业务通知"  /> 
                        <el-option value="9" label="营销短信"  />   
                    </el-select>
                </span>    
                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10" style="margin-right:25px;"  @click="refreshSearch">重置</el-button>
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >新增配置</el-button> 
               
               
          </el-card>
          <el-card shadow="hover"  class="containCard" >  
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="smsFrom" min-width="100" align="center" label="短信服务商">
                    <template slot-scope="scope" >   
                        <el-tag>{{scope.row.smsFrom==1?"阿里云":scope.row.smsFrom==2?"腾讯云":"其它"}}</el-tag>
                    </template> 
                </el-table-column>     
                <el-table-column prop="smsFrom" min-width="80" align="left" label="短信类型">
                    <template slot-scope="scope" >   
                        <p>{{scope.row.smsType==1?"验证码":scope.row.smsType==2?"运营通知":scope.row.smsType==3?"订单通知":
                            scope.row.smsType==4?"业务通知":scope.row.smsType==9?"营销短信":"其它"}}</p>
                    </template> 
                </el-table-column>
                <el-table-column prop="templateName" min-width="120" align="left" label="短信签名"> </el-table-column>      
                <el-table-column prop="templateCode" min-width="130" align="left" label="短信模板"> </el-table-column>       
                <el-table-column prop="fb1" min-width="100" align="left" label="变量名称1"> </el-table-column>       
                <el-table-column prop="fb2" min-width="100" align="left" label="变量名称2"> </el-table-column>       
                <el-table-column prop="appId" min-width="160" align="left" label="appId">
                    <template slot-scope="scope" >   
                        <p style="font-size:12px;">{{scope.row.appId }}</p>
                    </template> 
                </el-table-column>      
                <el-table-column prop="appKey" min-width="160" align="left" label="appKey">
                    <template slot-scope="scope" >   
                        <p  style="font-size:12px;">{{scope.row.appKey }}</p>
                    </template> 
                </el-table-column>    
                <el-table-column prop="status" min-width="80" align="center" label="启用状态">
                      <template slot-scope="scope" >   
                        <el-tooltip :content="scope.row.status=='1'?'已启用':'已关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column>  
                <el-table-column prop="createTime" min-width="165" align="center"  label="创建时间"> </el-table-column>  
                <el-table-column label="操作" min-width="140" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                         <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
          </el-card> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增配置" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="530px">
            <el-form ref="form1" :model="form1" label-width="90px" @submit.native.prevent="saveForm">
                <el-form-item label="短信服务商">
                    <el-radio-group  v-model.trim="form1.smsFrom" >
                        <el-radio-button label="1">阿里云</el-radio-button> 
                        <el-radio-button label="2">腾讯云</el-radio-button> 
                    </el-radio-group>   
                </el-form-item> 
                <el-form-item label="短信类型">
                     <el-radio-group  v-model.trim="form1.smsType" >
                        <el-radio-button label="1">验证码</el-radio-button> 
                        <el-radio-button label="2">运营通知</el-radio-button> 
                        <el-radio-button label="3">订单通知</el-radio-button> 
                        <el-radio-button label="4">业务通知</el-radio-button> 
                        <el-radio-button label="9">营销短信</el-radio-button> 
                    </el-radio-group>    
                </el-form-item> 
                <el-form-item label="短信签名">
                    <el-input v-model.trim="form1.templateName"  placeholder="短信签名" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="短信模板">
                    <el-input v-model.trim="form1.templateCode"  placeholder="短信模板" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="变量名称1">
                    <el-input v-model.trim="form1.fb1"  placeholder="短信模板" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="变量名称2">
                    <el-input v-model.trim="form1.fb2"  placeholder="短信模板" style="width:360px;"></el-input>
                </el-form-item> 
                 <el-form-item label="appId">
                    <el-input v-model.trim="form1.appId"  placeholder="appId" style="width:360px;"></el-input>
                </el-form-item> 
                 <el-form-item label="appKey">
                    <el-input v-model.trim="form1.appKey"  placeholder="appKey" style="width:360px;"></el-input>
                </el-form-item> 
                   
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑配置" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="530px">
            <el-form ref="form3" :model="form3" label-width="90px">
                <el-form-item label="短信服务商">
                    <el-radio-group  v-model.trim="form3.smsFrom" >
                        <el-radio-button label="1">阿里云</el-radio-button> 
                        <el-radio-button label="2">腾讯云</el-radio-button> 
                    </el-radio-group>   
                </el-form-item> 
                <el-form-item label="短信类型">
                     <el-radio-group  v-model.trim="form3.smsType" >
                        <el-radio-button label="1">验证码</el-radio-button> 
                        <el-radio-button label="2">运营通知</el-radio-button> 
                        <el-radio-button label="3">订单通知</el-radio-button> 
                        <el-radio-button label="4">业务通知</el-radio-button> 
                        <el-radio-button label="9">营销短信</el-radio-button> 
                    </el-radio-group>    
                </el-form-item> 
                <el-form-item label="短信签名">
                    <el-input v-model.trim="form3.templateName"  placeholder="短信签名" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="短信模板">
                    <el-input v-model.trim="form3.templateCode"  placeholder="短信模板" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="变量名称1">
                    <el-input v-model.trim="form3.fb1"  placeholder="短信模板" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="变量名称2">
                    <el-input v-model.trim="form3.fb2"  placeholder="短信模板" style="width:360px;"></el-input>
                </el-form-item> 
                 <el-form-item label="appId">
                    <el-input v-model.trim="form3.appId"  placeholder="appId" style="width:360px;"></el-input>
                </el-form-item> 
                 <el-form-item label="appKey">
                    <el-input v-model.trim="form3.appKey"  placeholder="appKey" style="width:360px;"></el-input>
                </el-form-item> 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
          
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus} from '../../api/comSms'; 
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                smsFrom:'1', 
                smsType:'1',  
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'smsType');  
            this.$set(this.query, 'smsFrom');    
            this.$set(this.query, 'templateName');    
            this.handleSearch();
        }, 
    

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 

        //查询
        getData(){  
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
          

        // 新增渠道
        addBind() {
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.templateName ){
                this.isSubmitting = false;
                this.$message.error("请填写短信签名");
                return;
            }  
            if( !this.form1.templateCode ){
                this.isSubmitting = false;
                this.$message.error("请填写短信模板");
                return;
            } 
            if( !this.form1.appId ){
                this.isSubmitting = false;
                this.$message.error("请填写短信appId");
                return;
            } 
            if( !this.form1.appKey ){
                this.isSubmitting = false;
                this.$message.error("请填写短信appKay");
                return;
            } 
            this.addVisible = false;  
            saveForm(this.form1).then(res => {
                this.isSubmitting = false; 
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.refreshSearch();
                }else{
                    this.addVisible = true;  
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.editVisible = true;
            this.form3 = row; 
        },
 
        
        // 保存更改
        saveEdit() {   
            if( !this.form3.templateName ){
                this.$message.error("请填写短信签名");
                return;
            }  
            if( !this.form3.templateCode ){
                this.$message.error("请填写短信模板");
                return;
            } 
            if( !this.form3.appId ){
                this.$message.error("请填写短信appId");
                return;
            } 
            if( !this.form3.appKey ){
                this.$message.error("请填写短信appKay");
                return;
            } 
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('确认删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
